<template>
    <div class="container">
        <!-- แสดงรายละเอียดถังดับเพลิง (ไม่ต้อง login) -->
        <Card class="extinguisher-card">
            <template #header> </template>
            <template #title>รายละเอียดถังดับเพลิง</template>
            <template #content>
                <div class="scrollable-content">
                    <ul v-if="extinguisherData" class="extinguisher-details">
                        <li><strong>ชื่อสถานที่:</strong> {{ extinguisherData.place_name }}</li>
                        <li><strong>เขต:</strong> {{ extinguisherData.country }}</li>
                        <li><strong>แขวง:</strong> {{ extinguisherData.subdistrict }}</li>
                        <li><strong>หมายเลขประจำถัง:</strong> {{ extinguisherData.code }}</li>
                        <li><strong>ประเภท:</strong> {{ extinguisherData.type }}</li>
                        <li><strong>ขนาดถังดับเพลิง:</strong> {{ extinguisherData.fire_extinguisher_size }} ปอนด์</li>
                        <li><strong>สลักล็อค:</strong> {{ convertStatus(extinguisherData.latch_lock) }}</li>
                        <li><strong>คันบังคับ:</strong> {{ convertStatus(extinguisherData.joystick) }}</li>
                        <li><strong>เกจความดัน:</strong> {{ convertStatus(extinguisherData.pressure_gauge) }}</li>
                        <li><strong>สายฉีด:</strong> {{ convertStatus(extinguisherData.line_spray) }}</li>
                        <li><strong>ตัวถัง:</strong> {{ convertStatus(extinguisherData.chassis) }}</li>
                        <li><strong>สถานะ:</strong> {{ extinguisherData.status }}</li>
                        <li><strong>วันที่หมดอายุ:</strong> {{ toThaiDateFormat(extinguisherData.date_expire) }}</li>
                        <li><strong>ประเภทสถานที่:</strong> {{ extinguisherData.location_type }}</li>
                        <li><strong>แก้ไขล่าสุดเมื่อ:</strong> {{ toThaiDateFormat(extinguisherData.date_update) }}</li>
                        <li><strong>ส.ด.พ. :</strong> {{ extinguisherData.fire_station }}</li>
                        <li><strong>ละติจูด:</strong> {{ extinguisherData.lat }}</li>
                        <li><strong>ลองจิจูด:</strong> {{ extinguisherData.lon }}</li>
                    </ul>
                </div>
                <div class="action-buttons" v-if="extinguisherData">
                    <Button
                        v-if="!loggedIn"
                        label="เข้าสู่ระบบเพื่อแก้ไขข้อมูล"
                        icon="pi pi-sign-in"
                        class="p-button-warning"
                        @click="requestLogin"
                    />
                    <Button
                        v-else
                        label="แก้ไขข้อมูล"
                        icon="pi pi-pencil"
                        class="p-button-warning"
                        @click="requestEdit"
                    />
                </div>
            </template>
        </Card>
    </div>
</template>

<script>
import axios from 'axios';
import Card from 'primevue/card';
import Button from 'primevue/button';
import EventBus from '../../../event-bus';

export default {
    name: 'ExtinguisherDetails',
    components: {
        Card,
        Button
    },
    props: {
        loggedIn: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        if (this.$route.query.code) {
            this.inputCode = this.$route.query.code;
            this.getFireExtinguisher_id();
        }
    },
    data() {
        return {
            inputCode: '',
            extinguisherData: null
        };
    },
    created() {
        window.onpopstate = () => {
            this.$router.push('/');
        };
    },
    methods: {
        convertStatus(value) {
            if (value === 'TRUE') {
                return 'ปกติ';
            } else if (value === 'FALSE') {
                return 'ชำรุด';
            }
            return value;
        },

        requestLogin() {
            EventBus.$emit('show-login-modal-from-route');
        },

        requestEdit() {
            if (!this.extinguisherData?.fx_id) {
                return;
            }
            this.$emit('edit-request', this.extinguisherData.fx_id);
        },

        getTelDetails(jsonString) {
            if (!jsonString) return '';
            const telDetailArray = JSON.parse(jsonString);
            return telDetailArray
                .map((detail) => {
                    return Object.values(detail)
                        .filter((val) => val !== '-')
                        .join(', ');
                })
                .join(', ');
        },
        toThaiDateFormat(dateString) {
            const options = { year: 'numeric', month: 'long', day: 'numeric' };
            const thaiDate = new Date(dateString).toLocaleDateString('th-TH', options);
            return thaiDate;
        },
        async getFireExtinguisher_id() {
            try {
                console.log('Fetching data for code:', this.inputCode);
                const code = this.inputCode;

                const response = await axios.post(
                    `${this.$url_service}/extinguisher/details/${code}`,
                    {},
                    {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }
                );

                const data = response.data;
                console.log('data:', data);
                if (data.code === 'success') {
                    this.extinguisherData = data.data[0];
                } else {
                    console.error('Error fetching data:', data.message);
                }
            } catch (error) {
                console.error('Error:', error);
            }
        }
    }
};
</script>

<style scoped>
.container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    background-color: #f5f5f5;
    padding: 20px;
}

.extinguisher-card {
    width: 100%;
    max-width: 400px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    background-color: #fff;
    padding: 20px;
}

.extinguisher-details {
    list-style: none;
    padding: 0;
    margin: 0;
    font-size: 1rem;
    line-height: 1.5;
    color: #333;
}

.extinguisher-details li {
    padding: 0.5em 0;
    border-bottom: 1px solid #eee;
}

.scrollable-content {
    max-height: 300px;
    overflow-y: auto;
    padding-right: 1em; /* Add padding to avoid content being hidden by scrollbar */
}

.action-buttons {
    margin-top: 1rem;
    text-align: center;
}

.login-required-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 2rem 1rem;
    text-align: center;
    color: #666;
    font-size: 1rem;
}

/* Small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
    .extinguisher-card {
        width: 100%;
        padding: 10px;
    }
}

/* Medium devices (tablets, 600px to 768px) */
@media only screen and (min-width: 600px) and (max-width: 768px) {
    .extinguisher-card {
        width: 90%;
        padding: 15px;
    }
}

/* Large devices (laptops/desktops, 768px and up) */
@media only screen and (min-width: 768px) {
    .extinguisher-card {
        width: 80%;
        padding: 20px;
    }
}
</style>
